import { render, staticRenderFns } from "./SendCouponDialog.vue?vue&type=template&id=35a2dda4&scoped=true&"
import script from "./SendCouponDialog.vue?vue&type=script&lang=js&"
export * from "./SendCouponDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2dda4",
  null
  
)

export default component.exports